export default "/fonts/trailblazerh-light.woff?e2aff92f82bee908977cb259ce654cfa";